// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Config from './config'
import VueMeta from 'vue-meta'
import VueFacebookPixel from 'vue-facebook-pixel'
import VueGtag from 'vue-gtag'

Vue.use(VueMeta)
Vue.use(VueFacebookPixel)
Vue.use(VueGtag, {
  config: { id: 'G-NNNLGN1BMP' }
}, router)

Vue.getShopifyID = (id, type = 'Product') => {
  if (!id) return console.error('No ID specified')
  // OLD VERSION USES BASE64 ENCODED STRING
  // return btoa('gid://shopify/' + type + '/' + id)
  // NEW VERSION DOES NOT USE BASE64 ENCODED STRING
  return 'gid://shopify/' + type + '/' + id
}

Vue.is = (name = '') => {
  if (name === 'mobile') return window.innerWidth <= Config.bkpt.mobile
  return false
}

Vue.updateMeta = {
  // _siteTitle: 'Staging > ' + Config.title,
  _siteTitle: Config.title,
  _siteDescription: 'Contemporary Products, Traditional Craftsmanship, Designed and Conceived in London',
  setTitle (pageTitle) {
    const title = pageTitle ? pageTitle + ' | ' + this._siteTitle : this._siteTitle
    document.title = title
  },
  setDescription (description) {
    description = !description ? this._siteDescription : description
    const meta = document.querySelector('meta[name="description"]')
    if (meta) meta.setAttribute('content', description)
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js